import { render, staticRenderFns } from "./discountCard.vue?vue&type=template&id=200972a4&scoped=true&"
import script from "./discountCard.vue?vue&type=script&lang=js&"
export * from "./discountCard.vue?vue&type=script&lang=js&"
import style0 from "./discountCard.vue?vue&type=style&index=0&id=200972a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200972a4",
  null
  
)

export default component.exports